/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateClient = /* GraphQL */ `
  subscription OnCreateClient($filter: ModelSubscriptionClientFilterInput) {
    onCreateClient(filter: $filter) {
      id
      clientId
      clientName
      contactName
      contactPhone
      contactEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateClient = /* GraphQL */ `
  subscription OnUpdateClient($filter: ModelSubscriptionClientFilterInput) {
    onUpdateClient(filter: $filter) {
      id
      clientId
      clientName
      contactName
      contactPhone
      contactEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteClient = /* GraphQL */ `
  subscription OnDeleteClient($filter: ModelSubscriptionClientFilterInput) {
    onDeleteClient(filter: $filter) {
      id
      clientId
      clientName
      contactName
      contactPhone
      contactEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateForecastedSales = /* GraphQL */ `
  subscription OnCreateForecastedSales(
    $filter: ModelSubscriptionForecastedSalesFilterInput
  ) {
    onCreateForecastedSales(filter: $filter) {
      id
      storeName
      date
      forecastedSales
      storeId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateForecastedSales = /* GraphQL */ `
  subscription OnUpdateForecastedSales(
    $filter: ModelSubscriptionForecastedSalesFilterInput
  ) {
    onUpdateForecastedSales(filter: $filter) {
      id
      storeName
      date
      forecastedSales
      storeId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteForecastedSales = /* GraphQL */ `
  subscription OnDeleteForecastedSales(
    $filter: ModelSubscriptionForecastedSalesFilterInput
  ) {
    onDeleteForecastedSales(filter: $filter) {
      id
      storeName
      date
      forecastedSales
      storeId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateHierarchyDefinition = /* GraphQL */ `
  subscription OnCreateHierarchyDefinition(
    $filter: ModelSubscriptionHierarchyDefinitionFilterInput
  ) {
    onCreateHierarchyDefinition(filter: $filter) {
      id
      clientId
      version
      effectiveDate
      endDate
      levels {
        levelId
        label
        order
        isUsed
        introducedInVersion
        __typename
      }
      changeReason
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onUpdateHierarchyDefinition = /* GraphQL */ `
  subscription OnUpdateHierarchyDefinition(
    $filter: ModelSubscriptionHierarchyDefinitionFilterInput
  ) {
    onUpdateHierarchyDefinition(filter: $filter) {
      id
      clientId
      version
      effectiveDate
      endDate
      levels {
        levelId
        label
        order
        isUsed
        introducedInVersion
        __typename
      }
      changeReason
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onDeleteHierarchyDefinition = /* GraphQL */ `
  subscription OnDeleteHierarchyDefinition(
    $filter: ModelSubscriptionHierarchyDefinitionFilterInput
  ) {
    onDeleteHierarchyDefinition(filter: $filter) {
      id
      clientId
      version
      effectiveDate
      endDate
      levels {
        levelId
        label
        order
        isUsed
        introducedInVersion
        __typename
      }
      changeReason
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onCreateOrgUnit = /* GraphQL */ `
  subscription OnCreateOrgUnit($filter: ModelSubscriptionOrgUnitFilterInput) {
    onCreateOrgUnit(filter: $filter) {
      id
      clientId
      orgLevel
      name
      isActive
      sortOrder
      parentOrgUnitId
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOrgUnit = /* GraphQL */ `
  subscription OnUpdateOrgUnit($filter: ModelSubscriptionOrgUnitFilterInput) {
    onUpdateOrgUnit(filter: $filter) {
      id
      clientId
      orgLevel
      name
      isActive
      sortOrder
      parentOrgUnitId
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOrgUnit = /* GraphQL */ `
  subscription OnDeleteOrgUnit($filter: ModelSubscriptionOrgUnitFilterInput) {
    onDeleteOrgUnit(filter: $filter) {
      id
      clientId
      orgLevel
      name
      isActive
      sortOrder
      parentOrgUnitId
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateStoreRecord = /* GraphQL */ `
  subscription OnCreateStoreRecord(
    $filter: ModelSubscriptionStoreRecordFilterInput
  ) {
    onCreateStoreRecord(filter: $filter) {
      id
      clientId
      storeId
      storeName
      storeNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      toastId
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      managerUserIds
      ownershipType
      conceptId
      tags
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateStoreRecord = /* GraphQL */ `
  subscription OnUpdateStoreRecord(
    $filter: ModelSubscriptionStoreRecordFilterInput
  ) {
    onUpdateStoreRecord(filter: $filter) {
      id
      clientId
      storeId
      storeName
      storeNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      toastId
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      managerUserIds
      ownershipType
      conceptId
      tags
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteStoreRecord = /* GraphQL */ `
  subscription OnDeleteStoreRecord(
    $filter: ModelSubscriptionStoreRecordFilterInput
  ) {
    onDeleteStoreRecord(filter: $filter) {
      id
      clientId
      storeId
      storeName
      storeNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      toastId
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      managerUserIds
      ownershipType
      conceptId
      tags
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLocation = /* GraphQL */ `
  subscription OnCreateLocation($filter: ModelSubscriptionLocationFilterInput) {
    onCreateLocation(filter: $filter) {
      id
      clientId
      locationName
      locationNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      ownershipType
      conceptId
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLocation = /* GraphQL */ `
  subscription OnUpdateLocation($filter: ModelSubscriptionLocationFilterInput) {
    onUpdateLocation(filter: $filter) {
      id
      clientId
      locationName
      locationNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      ownershipType
      conceptId
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLocation = /* GraphQL */ `
  subscription OnDeleteLocation($filter: ModelSubscriptionLocationFilterInput) {
    onDeleteLocation(filter: $filter) {
      id
      clientId
      locationName
      locationNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      ownershipType
      conceptId
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLocationLaborTargets = /* GraphQL */ `
  subscription OnCreateLocationLaborTargets(
    $filter: ModelSubscriptionLocationLaborTargetsFilterInput
  ) {
    onCreateLocationLaborTargets(filter: $filter) {
      id
      clientId
      locationId
      fohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      fohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      effectiveDate
      endDate
      isActive
      reason
      reasonType
      supersedes
      supersededBy
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLocationLaborTargets = /* GraphQL */ `
  subscription OnUpdateLocationLaborTargets(
    $filter: ModelSubscriptionLocationLaborTargetsFilterInput
  ) {
    onUpdateLocationLaborTargets(filter: $filter) {
      id
      clientId
      locationId
      fohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      fohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      effectiveDate
      endDate
      isActive
      reason
      reasonType
      supersedes
      supersededBy
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLocationLaborTargets = /* GraphQL */ `
  subscription OnDeleteLocationLaborTargets(
    $filter: ModelSubscriptionLocationLaborTargetsFilterInput
  ) {
    onDeleteLocationLaborTargets(filter: $filter) {
      id
      clientId
      locationId
      fohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      fohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      effectiveDate
      endDate
      isActive
      reason
      reasonType
      supersedes
      supersededBy
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onCreateRoleDefinition = /* GraphQL */ `
  subscription OnCreateRoleDefinition(
    $filter: ModelSubscriptionRoleDefinitionFilterInput
  ) {
    onCreateRoleDefinition(filter: $filter) {
      id
      clientId
      roleName
      roleCode
      assignmentLevel
      category
      sortOrder
      isActive
      isDefault
      metadata
      createdBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRoleDefinition = /* GraphQL */ `
  subscription OnUpdateRoleDefinition(
    $filter: ModelSubscriptionRoleDefinitionFilterInput
  ) {
    onUpdateRoleDefinition(filter: $filter) {
      id
      clientId
      roleName
      roleCode
      assignmentLevel
      category
      sortOrder
      isActive
      isDefault
      metadata
      createdBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRoleDefinition = /* GraphQL */ `
  subscription OnDeleteRoleDefinition(
    $filter: ModelSubscriptionRoleDefinitionFilterInput
  ) {
    onDeleteRoleDefinition(filter: $filter) {
      id
      clientId
      roleName
      roleCode
      assignmentLevel
      category
      sortOrder
      isActive
      isDefault
      metadata
      createdBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onCreateEmployee = /* GraphQL */ `
  subscription OnCreateEmployee($filter: ModelSubscriptionEmployeeFilterInput) {
    onCreateEmployee(filter: $filter) {
      id
      clientId
      firstName
      lastName
      email
      phoneNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      isActive
      employmentType
      hireDate
      terminationDate
      userId
      tags
      metadata
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEmployee = /* GraphQL */ `
  subscription OnUpdateEmployee($filter: ModelSubscriptionEmployeeFilterInput) {
    onUpdateEmployee(filter: $filter) {
      id
      clientId
      firstName
      lastName
      email
      phoneNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      isActive
      employmentType
      hireDate
      terminationDate
      userId
      tags
      metadata
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEmployee = /* GraphQL */ `
  subscription OnDeleteEmployee($filter: ModelSubscriptionEmployeeFilterInput) {
    onDeleteEmployee(filter: $filter) {
      id
      clientId
      firstName
      lastName
      email
      phoneNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      isActive
      employmentType
      hireDate
      terminationDate
      userId
      tags
      metadata
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onCreateLocationEmployee = /* GraphQL */ `
  subscription OnCreateLocationEmployee(
    $filter: ModelSubscriptionLocationEmployeeFilterInput
  ) {
    onCreateLocationEmployee(filter: $filter) {
      id
      clientId
      employeeId
      locationId
      roleDefinitionId
      isPrimary
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      locationNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLocationEmployee = /* GraphQL */ `
  subscription OnUpdateLocationEmployee(
    $filter: ModelSubscriptionLocationEmployeeFilterInput
  ) {
    onUpdateLocationEmployee(filter: $filter) {
      id
      clientId
      employeeId
      locationId
      roleDefinitionId
      isPrimary
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      locationNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLocationEmployee = /* GraphQL */ `
  subscription OnDeleteLocationEmployee(
    $filter: ModelSubscriptionLocationEmployeeFilterInput
  ) {
    onDeleteLocationEmployee(filter: $filter) {
      id
      clientId
      employeeId
      locationId
      roleDefinitionId
      isPrimary
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      locationNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const onCreateOrgUnitEmployee = /* GraphQL */ `
  subscription OnCreateOrgUnitEmployee(
    $filter: ModelSubscriptionOrgUnitEmployeeFilterInput
  ) {
    onCreateOrgUnitEmployee(filter: $filter) {
      id
      clientId
      employeeId
      orgUnitId
      managementLevel
      roleDefinitionId
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      orgUnitNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOrgUnitEmployee = /* GraphQL */ `
  subscription OnUpdateOrgUnitEmployee(
    $filter: ModelSubscriptionOrgUnitEmployeeFilterInput
  ) {
    onUpdateOrgUnitEmployee(filter: $filter) {
      id
      clientId
      employeeId
      orgUnitId
      managementLevel
      roleDefinitionId
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      orgUnitNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOrgUnitEmployee = /* GraphQL */ `
  subscription OnDeleteOrgUnitEmployee(
    $filter: ModelSubscriptionOrgUnitEmployeeFilterInput
  ) {
    onDeleteOrgUnitEmployee(filter: $filter) {
      id
      clientId
      employeeId
      orgUnitId
      managementLevel
      roleDefinitionId
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      orgUnitNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const onCreateBulkOperation = /* GraphQL */ `
  subscription OnCreateBulkOperation(
    $filter: ModelSubscriptionBulkOperationFilterInput
  ) {
    onCreateBulkOperation(filter: $filter) {
      id
      clientId
      operationType
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercent
      errorSummary
      errorDetails
      operationData
      previewData
      canUndo
      undoOperationId
      undoReason
      initiatedBy
      initiatedByName
      startedAt
      estimatedCompletion
      completedAt
      notificationsSent
      completionEmailSent
      description
      changeReason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBulkOperation = /* GraphQL */ `
  subscription OnUpdateBulkOperation(
    $filter: ModelSubscriptionBulkOperationFilterInput
  ) {
    onUpdateBulkOperation(filter: $filter) {
      id
      clientId
      operationType
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercent
      errorSummary
      errorDetails
      operationData
      previewData
      canUndo
      undoOperationId
      undoReason
      initiatedBy
      initiatedByName
      startedAt
      estimatedCompletion
      completedAt
      notificationsSent
      completionEmailSent
      description
      changeReason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBulkOperation = /* GraphQL */ `
  subscription OnDeleteBulkOperation(
    $filter: ModelSubscriptionBulkOperationFilterInput
  ) {
    onDeleteBulkOperation(filter: $filter) {
      id
      clientId
      operationType
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercent
      errorSummary
      errorDetails
      operationData
      previewData
      canUndo
      undoOperationId
      undoReason
      initiatedBy
      initiatedByName
      startedAt
      estimatedCompletion
      completedAt
      notificationsSent
      completionEmailSent
      description
      changeReason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateHierarchyChangeLog = /* GraphQL */ `
  subscription OnCreateHierarchyChangeLog(
    $filter: ModelSubscriptionHierarchyChangeLogFilterInput
  ) {
    onCreateHierarchyChangeLog(filter: $filter) {
      id
      clientId
      changeType
      affectedLocations
      affectedOrgUnits
      changeDetails {
        entityType
        entityId
        entityName
        operationType
        fieldChanges {
          fieldName
          oldValue
          oldDisplayValue
          newValue
          newDisplayValue
          __typename
        }
        metadata
        __typename
      }
      changeSummary
      changeReason
      changedBy
      changedByName
      changedAt
      bulkOperationId
      snapshotId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateHierarchyChangeLog = /* GraphQL */ `
  subscription OnUpdateHierarchyChangeLog(
    $filter: ModelSubscriptionHierarchyChangeLogFilterInput
  ) {
    onUpdateHierarchyChangeLog(filter: $filter) {
      id
      clientId
      changeType
      affectedLocations
      affectedOrgUnits
      changeDetails {
        entityType
        entityId
        entityName
        operationType
        fieldChanges {
          fieldName
          oldValue
          oldDisplayValue
          newValue
          newDisplayValue
          __typename
        }
        metadata
        __typename
      }
      changeSummary
      changeReason
      changedBy
      changedByName
      changedAt
      bulkOperationId
      snapshotId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteHierarchyChangeLog = /* GraphQL */ `
  subscription OnDeleteHierarchyChangeLog(
    $filter: ModelSubscriptionHierarchyChangeLogFilterInput
  ) {
    onDeleteHierarchyChangeLog(filter: $filter) {
      id
      clientId
      changeType
      affectedLocations
      affectedOrgUnits
      changeDetails {
        entityType
        entityId
        entityName
        operationType
        fieldChanges {
          fieldName
          oldValue
          oldDisplayValue
          newValue
          newDisplayValue
          __typename
        }
        metadata
        __typename
      }
      changeSummary
      changeReason
      changedBy
      changedByName
      changedAt
      bulkOperationId
      snapshotId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateHierarchySnapshot = /* GraphQL */ `
  subscription OnCreateHierarchySnapshot(
    $filter: ModelSubscriptionHierarchySnapshotFilterInput
  ) {
    onCreateHierarchySnapshot(filter: $filter) {
      id
      clientId
      snapshotDate
      locations {
        locationId
        locationName
        orgLevel_1
        orgLevel_1_name
        orgLevel_2
        orgLevel_2_name
        orgLevel_3
        orgLevel_3_name
        laborTargets {
          fohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          bohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          fohVariableHours
          bohVariableHours
          salesBase
          effectiveDate
          __typename
        }
        isActive
        closeDate
        __typename
      }
      orgUnits {
        orgUnitId
        name
        orgLevel
        parentOrgUnitId
        parentOrgUnitName
        isActive
        __typename
      }
      hierarchyChangeLogId
      reason
      createdAt
      createdBy
      createdByName
      totalLocations
      totalOrgUnits
      snapshotType
      updatedAt
      __typename
    }
  }
`;
export const onUpdateHierarchySnapshot = /* GraphQL */ `
  subscription OnUpdateHierarchySnapshot(
    $filter: ModelSubscriptionHierarchySnapshotFilterInput
  ) {
    onUpdateHierarchySnapshot(filter: $filter) {
      id
      clientId
      snapshotDate
      locations {
        locationId
        locationName
        orgLevel_1
        orgLevel_1_name
        orgLevel_2
        orgLevel_2_name
        orgLevel_3
        orgLevel_3_name
        laborTargets {
          fohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          bohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          fohVariableHours
          bohVariableHours
          salesBase
          effectiveDate
          __typename
        }
        isActive
        closeDate
        __typename
      }
      orgUnits {
        orgUnitId
        name
        orgLevel
        parentOrgUnitId
        parentOrgUnitName
        isActive
        __typename
      }
      hierarchyChangeLogId
      reason
      createdAt
      createdBy
      createdByName
      totalLocations
      totalOrgUnits
      snapshotType
      updatedAt
      __typename
    }
  }
`;
export const onDeleteHierarchySnapshot = /* GraphQL */ `
  subscription OnDeleteHierarchySnapshot(
    $filter: ModelSubscriptionHierarchySnapshotFilterInput
  ) {
    onDeleteHierarchySnapshot(filter: $filter) {
      id
      clientId
      snapshotDate
      locations {
        locationId
        locationName
        orgLevel_1
        orgLevel_1_name
        orgLevel_2
        orgLevel_2_name
        orgLevel_3
        orgLevel_3_name
        laborTargets {
          fohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          bohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          fohVariableHours
          bohVariableHours
          salesBase
          effectiveDate
          __typename
        }
        isActive
        closeDate
        __typename
      }
      orgUnits {
        orgUnitId
        name
        orgLevel
        parentOrgUnitId
        parentOrgUnitName
        isActive
        __typename
      }
      hierarchyChangeLogId
      reason
      createdAt
      createdBy
      createdByName
      totalLocations
      totalOrgUnits
      snapshotType
      updatedAt
      __typename
    }
  }
`;
export const onCreateHierarchyConstraint = /* GraphQL */ `
  subscription OnCreateHierarchyConstraint(
    $filter: ModelSubscriptionHierarchyConstraintFilterInput
  ) {
    onCreateHierarchyConstraint(filter: $filter) {
      id
      clientId
      constraintType
      config
      targetLevel
      isActive
      enforcement
      name
      description
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onUpdateHierarchyConstraint = /* GraphQL */ `
  subscription OnUpdateHierarchyConstraint(
    $filter: ModelSubscriptionHierarchyConstraintFilterInput
  ) {
    onUpdateHierarchyConstraint(filter: $filter) {
      id
      clientId
      constraintType
      config
      targetLevel
      isActive
      enforcement
      name
      description
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onDeleteHierarchyConstraint = /* GraphQL */ `
  subscription OnDeleteHierarchyConstraint(
    $filter: ModelSubscriptionHierarchyConstraintFilterInput
  ) {
    onDeleteHierarchyConstraint(filter: $filter) {
      id
      clientId
      constraintType
      config
      targetLevel
      isActive
      enforcement
      name
      description
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onCreateTagCatalog = /* GraphQL */ `
  subscription OnCreateTagCatalog(
    $filter: ModelSubscriptionTagCatalogFilterInput
  ) {
    onCreateTagCatalog(filter: $filter) {
      id
      clientId
      applicableTypes
      category
      label
      value
      description
      isActive
      isSystem
      metadata
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTagCatalog = /* GraphQL */ `
  subscription OnUpdateTagCatalog(
    $filter: ModelSubscriptionTagCatalogFilterInput
  ) {
    onUpdateTagCatalog(filter: $filter) {
      id
      clientId
      applicableTypes
      category
      label
      value
      description
      isActive
      isSystem
      metadata
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTagCatalog = /* GraphQL */ `
  subscription OnDeleteTagCatalog(
    $filter: ModelSubscriptionTagCatalogFilterInput
  ) {
    onDeleteTagCatalog(filter: $filter) {
      id
      clientId
      applicableTypes
      category
      label
      value
      description
      isActive
      isSystem
      metadata
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const onCreateTagAssignment = /* GraphQL */ `
  subscription OnCreateTagAssignment(
    $filter: ModelSubscriptionTagAssignmentFilterInput
  ) {
    onCreateTagAssignment(filter: $filter) {
      id
      clientId
      entityType
      entityId
      tagCatalogId
      tagLabel
      tagCategory
      assignedBy
      assignedAt
      isActive
      context
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTagAssignment = /* GraphQL */ `
  subscription OnUpdateTagAssignment(
    $filter: ModelSubscriptionTagAssignmentFilterInput
  ) {
    onUpdateTagAssignment(filter: $filter) {
      id
      clientId
      entityType
      entityId
      tagCatalogId
      tagLabel
      tagCategory
      assignedBy
      assignedAt
      isActive
      context
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTagAssignment = /* GraphQL */ `
  subscription OnDeleteTagAssignment(
    $filter: ModelSubscriptionTagAssignmentFilterInput
  ) {
    onDeleteTagAssignment(filter: $filter) {
      id
      clientId
      entityType
      entityId
      tagCatalogId
      tagLabel
      tagCategory
      assignedBy
      assignedAt
      isActive
      context
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
    onCreateUser(filter: $filter) {
      id
      client
      userName
      firstName
      lastName
      email
      role
      group
      groupRole
      employeeId
      status
      securityVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
    onUpdateUser(filter: $filter) {
      id
      client
      userName
      firstName
      lastName
      email
      role
      group
      groupRole
      employeeId
      status
      securityVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
    onDeleteUser(filter: $filter) {
      id
      client
      userName
      firstName
      lastName
      email
      role
      group
      groupRole
      employeeId
      status
      securityVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateResourceType = /* GraphQL */ `
  subscription OnCreateResourceType(
    $filter: ModelSubscriptionResourceTypeFilterInput
  ) {
    onCreateResourceType(filter: $filter) {
      id
      name
      resourcePrefix
      icon
      description
      status
      domainRestrictions
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateResourceType = /* GraphQL */ `
  subscription OnUpdateResourceType(
    $filter: ModelSubscriptionResourceTypeFilterInput
  ) {
    onUpdateResourceType(filter: $filter) {
      id
      name
      resourcePrefix
      icon
      description
      status
      domainRestrictions
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteResourceType = /* GraphQL */ `
  subscription OnDeleteResourceType(
    $filter: ModelSubscriptionResourceTypeFilterInput
  ) {
    onDeleteResourceType(filter: $filter) {
      id
      name
      resourcePrefix
      icon
      description
      status
      domainRestrictions
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateResourceCatalog = /* GraphQL */ `
  subscription OnCreateResourceCatalog(
    $filter: ModelSubscriptionResourceCatalogFilterInput
  ) {
    onCreateResourceCatalog(filter: $filter) {
      id
      resourceCode
      resourceTypeId
      domain
      name
      description
      icon
      route
      componentPath
      defaultActions
      status
      version
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateResourceCatalog = /* GraphQL */ `
  subscription OnUpdateResourceCatalog(
    $filter: ModelSubscriptionResourceCatalogFilterInput
  ) {
    onUpdateResourceCatalog(filter: $filter) {
      id
      resourceCode
      resourceTypeId
      domain
      name
      description
      icon
      route
      componentPath
      defaultActions
      status
      version
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteResourceCatalog = /* GraphQL */ `
  subscription OnDeleteResourceCatalog(
    $filter: ModelSubscriptionResourceCatalogFilterInput
  ) {
    onDeleteResourceCatalog(filter: $filter) {
      id
      resourceCode
      resourceTypeId
      domain
      name
      description
      icon
      route
      componentPath
      defaultActions
      status
      version
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateClientResourceMap = /* GraphQL */ `
  subscription OnCreateClientResourceMap(
    $filter: ModelSubscriptionClientResourceMapFilterInput
  ) {
    onCreateClientResourceMap(filter: $filter) {
      id
      clientId
      resourceId
      isEnabled
      customLabel
      customTooltip
      customDescription
      customIcon
      allowedActionsOverride
      order
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateClientResourceMap = /* GraphQL */ `
  subscription OnUpdateClientResourceMap(
    $filter: ModelSubscriptionClientResourceMapFilterInput
  ) {
    onUpdateClientResourceMap(filter: $filter) {
      id
      clientId
      resourceId
      isEnabled
      customLabel
      customTooltip
      customDescription
      customIcon
      allowedActionsOverride
      order
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteClientResourceMap = /* GraphQL */ `
  subscription OnDeleteClientResourceMap(
    $filter: ModelSubscriptionClientResourceMapFilterInput
  ) {
    onDeleteClientResourceMap(filter: $filter) {
      id
      clientId
      resourceId
      isEnabled
      customLabel
      customTooltip
      customDescription
      customIcon
      allowedActionsOverride
      order
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserEmployee = /* GraphQL */ `
  subscription OnCreateUserEmployee(
    $filter: ModelSubscriptionUserEmployeeFilterInput
  ) {
    onCreateUserEmployee(filter: $filter) {
      id
      userId
      employeeId
      client
      linkedAt
      linkedBy
      unlinkedAt
      unlinkedBy
      isActive
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserEmployee = /* GraphQL */ `
  subscription OnUpdateUserEmployee(
    $filter: ModelSubscriptionUserEmployeeFilterInput
  ) {
    onUpdateUserEmployee(filter: $filter) {
      id
      userId
      employeeId
      client
      linkedAt
      linkedBy
      unlinkedAt
      unlinkedBy
      isActive
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserEmployee = /* GraphQL */ `
  subscription OnDeleteUserEmployee(
    $filter: ModelSubscriptionUserEmployeeFilterInput
  ) {
    onDeleteUserEmployee(filter: $filter) {
      id
      userId
      employeeId
      client
      linkedAt
      linkedBy
      unlinkedAt
      unlinkedBy
      isActive
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateGrant = /* GraphQL */ `
  subscription OnCreateGrant($filter: ModelSubscriptionGrantFilterInput) {
    onCreateGrant(filter: $filter) {
      id
      clientId
      name
      description
      targetDomain
      targetResourceTypeId
      targetResourceId
      targetResourcePattern
      subjectType
      subjectValue
      actionConfigs {
        action
        effect
        scopeConfig {
          includeChildren
          includePeers
          includeParent
          __typename
        }
        constraints
        priority
        __typename
      }
      priority
      constraints
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      grantSignature
      __typename
    }
  }
`;
export const onUpdateGrant = /* GraphQL */ `
  subscription OnUpdateGrant($filter: ModelSubscriptionGrantFilterInput) {
    onUpdateGrant(filter: $filter) {
      id
      clientId
      name
      description
      targetDomain
      targetResourceTypeId
      targetResourceId
      targetResourcePattern
      subjectType
      subjectValue
      actionConfigs {
        action
        effect
        scopeConfig {
          includeChildren
          includePeers
          includeParent
          __typename
        }
        constraints
        priority
        __typename
      }
      priority
      constraints
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      grantSignature
      __typename
    }
  }
`;
export const onDeleteGrant = /* GraphQL */ `
  subscription OnDeleteGrant($filter: ModelSubscriptionGrantFilterInput) {
    onDeleteGrant(filter: $filter) {
      id
      clientId
      name
      description
      targetDomain
      targetResourceTypeId
      targetResourceId
      targetResourcePattern
      subjectType
      subjectValue
      actionConfigs {
        action
        effect
        scopeConfig {
          includeChildren
          includePeers
          includeParent
          __typename
        }
        constraints
        priority
        __typename
      }
      priority
      constraints
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      grantSignature
      __typename
    }
  }
`;
export const onCreateUserPermissionsCache = /* GraphQL */ `
  subscription OnCreateUserPermissionsCache(
    $filter: ModelSubscriptionUserPermissionsCacheFilterInput
  ) {
    onCreateUserPermissionsCache(filter: $filter) {
      id
      clientId
      userId
      group
      groupRole
      permissions
      navigation
      dataScope {
        scopeType
        assignedLocations
        assignedOrgUnits
        accessibleLocations
        accessibleOrgUnits
        includeChildren
        includePeers
        includeParent
        calculatedAt
        calculatedFrom
        __typename
      }
      version
      calculatedAt
      lastUsed
      securityVersion
      hash
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserPermissionsCache = /* GraphQL */ `
  subscription OnUpdateUserPermissionsCache(
    $filter: ModelSubscriptionUserPermissionsCacheFilterInput
  ) {
    onUpdateUserPermissionsCache(filter: $filter) {
      id
      clientId
      userId
      group
      groupRole
      permissions
      navigation
      dataScope {
        scopeType
        assignedLocations
        assignedOrgUnits
        accessibleLocations
        accessibleOrgUnits
        includeChildren
        includePeers
        includeParent
        calculatedAt
        calculatedFrom
        __typename
      }
      version
      calculatedAt
      lastUsed
      securityVersion
      hash
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserPermissionsCache = /* GraphQL */ `
  subscription OnDeleteUserPermissionsCache(
    $filter: ModelSubscriptionUserPermissionsCacheFilterInput
  ) {
    onDeleteUserPermissionsCache(filter: $filter) {
      id
      clientId
      userId
      group
      groupRole
      permissions
      navigation
      dataScope {
        scopeType
        assignedLocations
        assignedOrgUnits
        accessibleLocations
        accessibleOrgUnits
        includeChildren
        includePeers
        includeParent
        calculatedAt
        calculatedFrom
        __typename
      }
      version
      calculatedAt
      lastUsed
      securityVersion
      hash
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateMetricData = /* GraphQL */ `
  subscription OnCreateMetricData(
    $filter: ModelSubscriptionMetricDataFilterInput
  ) {
    onCreateMetricData(filter: $filter) {
      metricId
      clientId
      storeId
      date
      hour
      frequency
      metricName
      metricType
      numberValue
      stringValue
      booleanValue
      dayPart
      diningOption
      source
      timestamp
      unit
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMetricData = /* GraphQL */ `
  subscription OnUpdateMetricData(
    $filter: ModelSubscriptionMetricDataFilterInput
  ) {
    onUpdateMetricData(filter: $filter) {
      metricId
      clientId
      storeId
      date
      hour
      frequency
      metricName
      metricType
      numberValue
      stringValue
      booleanValue
      dayPart
      diningOption
      source
      timestamp
      unit
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMetricData = /* GraphQL */ `
  subscription OnDeleteMetricData(
    $filter: ModelSubscriptionMetricDataFilterInput
  ) {
    onDeleteMetricData(filter: $filter) {
      metricId
      clientId
      storeId
      date
      hour
      frequency
      metricName
      metricType
      numberValue
      stringValue
      booleanValue
      dayPart
      diningOption
      source
      timestamp
      unit
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateThreshold = /* GraphQL */ `
  subscription OnCreateThreshold(
    $filter: ModelSubscriptionThresholdFilterInput
  ) {
    onCreateThreshold(filter: $filter) {
      id
      clientId
      name
      entityType
      entityId
      metric
      thresholdType
      thresholdBands {
        position
        operator
        numberValue
        textValue
        backgroundColor
        color
        fontWeight
        fontStyle
        borderColor
        borderWidth
        icon
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateThreshold = /* GraphQL */ `
  subscription OnUpdateThreshold(
    $filter: ModelSubscriptionThresholdFilterInput
  ) {
    onUpdateThreshold(filter: $filter) {
      id
      clientId
      name
      entityType
      entityId
      metric
      thresholdType
      thresholdBands {
        position
        operator
        numberValue
        textValue
        backgroundColor
        color
        fontWeight
        fontStyle
        borderColor
        borderWidth
        icon
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteThreshold = /* GraphQL */ `
  subscription OnDeleteThreshold(
    $filter: ModelSubscriptionThresholdFilterInput
  ) {
    onDeleteThreshold(filter: $filter) {
      id
      clientId
      name
      entityType
      entityId
      metric
      thresholdType
      thresholdBands {
        position
        operator
        numberValue
        textValue
        backgroundColor
        color
        fontWeight
        fontStyle
        borderColor
        borderWidth
        icon
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateThresholdMapping = /* GraphQL */ `
  subscription OnCreateThresholdMapping(
    $filter: ModelSubscriptionThresholdMappingFilterInput
  ) {
    onCreateThresholdMapping(filter: $filter) {
      id
      entityId
      extEntityId
      thresholdId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateThresholdMapping = /* GraphQL */ `
  subscription OnUpdateThresholdMapping(
    $filter: ModelSubscriptionThresholdMappingFilterInput
  ) {
    onUpdateThresholdMapping(filter: $filter) {
      id
      entityId
      extEntityId
      thresholdId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteThresholdMapping = /* GraphQL */ `
  subscription OnDeleteThresholdMapping(
    $filter: ModelSubscriptionThresholdMappingFilterInput
  ) {
    onDeleteThresholdMapping(filter: $filter) {
      id
      entityId
      extEntityId
      thresholdId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateControlTable = /* GraphQL */ `
  subscription OnCreateControlTable(
    $filter: ModelSubscriptionControlTableFilterInput
  ) {
    onCreateControlTable(filter: $filter) {
      taskId
      executionId
      jobDefinitionId
      clientId
      dataSource
      dataCategory
      sourceIdentifier
      timeRangeStart
      timeRangeEnd
      status
      recordsProcessed
      startTime
      endTime
      processingDuration
      errorDetails
      retryCount
      validationStatus
      validationDiscrepancies
      validationNotes
      priority
      lastUpdated
      createdBy
      version
      parentTaskId
      clientDataSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateControlTable = /* GraphQL */ `
  subscription OnUpdateControlTable(
    $filter: ModelSubscriptionControlTableFilterInput
  ) {
    onUpdateControlTable(filter: $filter) {
      taskId
      executionId
      jobDefinitionId
      clientId
      dataSource
      dataCategory
      sourceIdentifier
      timeRangeStart
      timeRangeEnd
      status
      recordsProcessed
      startTime
      endTime
      processingDuration
      errorDetails
      retryCount
      validationStatus
      validationDiscrepancies
      validationNotes
      priority
      lastUpdated
      createdBy
      version
      parentTaskId
      clientDataSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteControlTable = /* GraphQL */ `
  subscription OnDeleteControlTable(
    $filter: ModelSubscriptionControlTableFilterInput
  ) {
    onDeleteControlTable(filter: $filter) {
      taskId
      executionId
      jobDefinitionId
      clientId
      dataSource
      dataCategory
      sourceIdentifier
      timeRangeStart
      timeRangeEnd
      status
      recordsProcessed
      startTime
      endTime
      processingDuration
      errorDetails
      retryCount
      validationStatus
      validationDiscrepancies
      validationNotes
      priority
      lastUpdated
      createdBy
      version
      parentTaskId
      clientDataSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateJobDefinition = /* GraphQL */ `
  subscription OnCreateJobDefinition(
    $filter: ModelSubscriptionJobDefinitionFilterInput
  ) {
    onCreateJobDefinition(filter: $filter) {
      jobDefinitionId
      name
      description
      clientId
      dataSource
      sourceEndpoint
      sourceFilters {
        name
        values
        __typename
      }
      dataTimeConfig {
        mode
        relativeValue
        relativeUnit
        offset
        startDateTime
        endDateTime
        granularity
        __typename
      }
      scheduleConfig {
        mode
        cronExpression
        timeZoneStrategy
        specificTimeZone
        scheduleStartDate
        scheduleEndDate
        scheduledTime
        __typename
      }
      status
      createdBy
      createdAt
      lastModified
      settings
      clientDataSource
      updatedAt
      __typename
    }
  }
`;
export const onUpdateJobDefinition = /* GraphQL */ `
  subscription OnUpdateJobDefinition(
    $filter: ModelSubscriptionJobDefinitionFilterInput
  ) {
    onUpdateJobDefinition(filter: $filter) {
      jobDefinitionId
      name
      description
      clientId
      dataSource
      sourceEndpoint
      sourceFilters {
        name
        values
        __typename
      }
      dataTimeConfig {
        mode
        relativeValue
        relativeUnit
        offset
        startDateTime
        endDateTime
        granularity
        __typename
      }
      scheduleConfig {
        mode
        cronExpression
        timeZoneStrategy
        specificTimeZone
        scheduleStartDate
        scheduleEndDate
        scheduledTime
        __typename
      }
      status
      createdBy
      createdAt
      lastModified
      settings
      clientDataSource
      updatedAt
      __typename
    }
  }
`;
export const onDeleteJobDefinition = /* GraphQL */ `
  subscription OnDeleteJobDefinition(
    $filter: ModelSubscriptionJobDefinitionFilterInput
  ) {
    onDeleteJobDefinition(filter: $filter) {
      jobDefinitionId
      name
      description
      clientId
      dataSource
      sourceEndpoint
      sourceFilters {
        name
        values
        __typename
      }
      dataTimeConfig {
        mode
        relativeValue
        relativeUnit
        offset
        startDateTime
        endDateTime
        granularity
        __typename
      }
      scheduleConfig {
        mode
        cronExpression
        timeZoneStrategy
        specificTimeZone
        scheduleStartDate
        scheduleEndDate
        scheduledTime
        __typename
      }
      status
      createdBy
      createdAt
      lastModified
      settings
      clientDataSource
      updatedAt
      __typename
    }
  }
`;
export const onCreateJobExecution = /* GraphQL */ `
  subscription OnCreateJobExecution(
    $filter: ModelSubscriptionJobExecutionFilterInput
  ) {
    onCreateJobExecution(filter: $filter) {
      executionId
      jobDefinitionId
      executionNumber
      clientId
      timeRangeStart
      timeRangeEnd
      status
      startTime
      endTime
      tasksTotal
      tasksSucceeded
      tasksFailed
      recordsProcessed
      triggeredBy
      lastUpdated
      errorSummary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateJobExecution = /* GraphQL */ `
  subscription OnUpdateJobExecution(
    $filter: ModelSubscriptionJobExecutionFilterInput
  ) {
    onUpdateJobExecution(filter: $filter) {
      executionId
      jobDefinitionId
      executionNumber
      clientId
      timeRangeStart
      timeRangeEnd
      status
      startTime
      endTime
      tasksTotal
      tasksSucceeded
      tasksFailed
      recordsProcessed
      triggeredBy
      lastUpdated
      errorSummary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteJobExecution = /* GraphQL */ `
  subscription OnDeleteJobExecution(
    $filter: ModelSubscriptionJobExecutionFilterInput
  ) {
    onDeleteJobExecution(filter: $filter) {
      executionId
      jobDefinitionId
      executionNumber
      clientId
      timeRangeStart
      timeRangeEnd
      status
      startTime
      endTime
      tasksTotal
      tasksSucceeded
      tasksFailed
      recordsProcessed
      triggeredBy
      lastUpdated
      errorSummary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDemoBaseline = /* GraphQL */ `
  subscription OnCreateDemoBaseline(
    $filter: ModelSubscriptionDemoBaselineFilterInput
  ) {
    onCreateDemoBaseline(filter: $filter) {
      clientId
      auv
      avgCheck
      laborPct
      fohWage
      bohWage
      fohBohSplit
      noiseSigma
      baseSeed
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDemoBaseline = /* GraphQL */ `
  subscription OnUpdateDemoBaseline(
    $filter: ModelSubscriptionDemoBaselineFilterInput
  ) {
    onUpdateDemoBaseline(filter: $filter) {
      clientId
      auv
      avgCheck
      laborPct
      fohWage
      bohWage
      fohBohSplit
      noiseSigma
      baseSeed
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDemoBaseline = /* GraphQL */ `
  subscription OnDeleteDemoBaseline(
    $filter: ModelSubscriptionDemoBaselineFilterInput
  ) {
    onDeleteDemoBaseline(filter: $filter) {
      clientId
      auv
      avgCheck
      laborPct
      fohWage
      bohWage
      fohBohSplit
      noiseSigma
      baseSeed
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDemoSeasonality = /* GraphQL */ `
  subscription OnCreateDemoSeasonality(
    $filter: ModelSubscriptionDemoSeasonalityFilterInput
  ) {
    onCreateDemoSeasonality(filter: $filter) {
      seasonalityKey
      monthly
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDemoSeasonality = /* GraphQL */ `
  subscription OnUpdateDemoSeasonality(
    $filter: ModelSubscriptionDemoSeasonalityFilterInput
  ) {
    onUpdateDemoSeasonality(filter: $filter) {
      seasonalityKey
      monthly
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDemoSeasonality = /* GraphQL */ `
  subscription OnDeleteDemoSeasonality(
    $filter: ModelSubscriptionDemoSeasonalityFilterInput
  ) {
    onDeleteDemoSeasonality(filter: $filter) {
      seasonalityKey
      monthly
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDemoWeekdayProfile = /* GraphQL */ `
  subscription OnCreateDemoWeekdayProfile(
    $filter: ModelSubscriptionDemoWeekdayProfileFilterInput
  ) {
    onCreateDemoWeekdayProfile(filter: $filter) {
      profileKey
      weekday
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDemoWeekdayProfile = /* GraphQL */ `
  subscription OnUpdateDemoWeekdayProfile(
    $filter: ModelSubscriptionDemoWeekdayProfileFilterInput
  ) {
    onUpdateDemoWeekdayProfile(filter: $filter) {
      profileKey
      weekday
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDemoWeekdayProfile = /* GraphQL */ `
  subscription OnDeleteDemoWeekdayProfile(
    $filter: ModelSubscriptionDemoWeekdayProfileFilterInput
  ) {
    onDeleteDemoWeekdayProfile(filter: $filter) {
      profileKey
      weekday
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDemoUnitConfig = /* GraphQL */ `
  subscription OnCreateDemoUnitConfig(
    $filter: ModelSubscriptionDemoUnitConfigFilterInput
  ) {
    onCreateDemoUnitConfig(filter: $filter) {
      clientId
      entityId
      orgLevel
      salesMult
      avgCheckMult
      laborPctDelta
      wageMult
      seasonalityKey
      weekdayProfileKey
      throughputCap
      tags
      notes
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDemoUnitConfig = /* GraphQL */ `
  subscription OnUpdateDemoUnitConfig(
    $filter: ModelSubscriptionDemoUnitConfigFilterInput
  ) {
    onUpdateDemoUnitConfig(filter: $filter) {
      clientId
      entityId
      orgLevel
      salesMult
      avgCheckMult
      laborPctDelta
      wageMult
      seasonalityKey
      weekdayProfileKey
      throughputCap
      tags
      notes
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDemoUnitConfig = /* GraphQL */ `
  subscription OnDeleteDemoUnitConfig(
    $filter: ModelSubscriptionDemoUnitConfigFilterInput
  ) {
    onDeleteDemoUnitConfig(filter: $filter) {
      clientId
      entityId
      orgLevel
      salesMult
      avgCheckMult
      laborPctDelta
      wageMult
      seasonalityKey
      weekdayProfileKey
      throughputCap
      tags
      notes
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDemoAtomicShiftDaily = /* GraphQL */ `
  subscription OnCreateDemoAtomicShiftDaily(
    $filter: ModelSubscriptionDemoAtomicShiftDailyFilterInput
  ) {
    onCreateDemoAtomicShiftDaily(filter: $filter) {
      clientId
      locationId
      date
      shift
      netSales
      checkCount
      fohDollars
      bohDollars
      fohHours
      bohHours
      splh
      laborPct
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDemoAtomicShiftDaily = /* GraphQL */ `
  subscription OnUpdateDemoAtomicShiftDaily(
    $filter: ModelSubscriptionDemoAtomicShiftDailyFilterInput
  ) {
    onUpdateDemoAtomicShiftDaily(filter: $filter) {
      clientId
      locationId
      date
      shift
      netSales
      checkCount
      fohDollars
      bohDollars
      fohHours
      bohHours
      splh
      laborPct
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDemoAtomicShiftDaily = /* GraphQL */ `
  subscription OnDeleteDemoAtomicShiftDaily(
    $filter: ModelSubscriptionDemoAtomicShiftDailyFilterInput
  ) {
    onDeleteDemoAtomicShiftDaily(filter: $filter) {
      clientId
      locationId
      date
      shift
      netSales
      checkCount
      fohDollars
      bohDollars
      fohHours
      bohHours
      splh
      laborPct
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDemoRun = /* GraphQL */ `
  subscription OnCreateDemoRun($filter: ModelSubscriptionDemoRunFilterInput) {
    onCreateDemoRun(filter: $filter) {
      clientId
      runId
      operation
      scopeType
      scopeId
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      status
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDemoRun = /* GraphQL */ `
  subscription OnUpdateDemoRun($filter: ModelSubscriptionDemoRunFilterInput) {
    onUpdateDemoRun(filter: $filter) {
      clientId
      runId
      operation
      scopeType
      scopeId
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      status
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDemoRun = /* GraphQL */ `
  subscription OnDeleteDemoRun($filter: ModelSubscriptionDemoRunFilterInput) {
    onDeleteDemoRun(filter: $filter) {
      clientId
      runId
      operation
      scopeType
      scopeId
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      status
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
